var map = {
	"./Slider": 44,
	"./Slider.js": 44,
	"./config": 31,
	"./config.js": 31,
	"./img/1.jpg": 168,
	"./img/1.png": 169,
	"./img/2.jpg": 170,
	"./img/2.png": 171,
	"./img/3.jpg": 172,
	"./img/3.png": 173,
	"./img/4.jpg": 174,
	"./img/4.png": 175,
	"./img/frame1.jpg": 176,
	"./img/frame2.jpg": 177,
	"./img/frame3.jpg": 178,
	"./img/frame3a.jpg": 179,
	"./img/frame4.jpg": 180,
	"./img/gonerdify.net_Book_delivery.png": 181,
	"./img/gonerdify.net_Personal_Nerd.png": 182,
	"./img/gonerdify.net_Presentation_help.png": 183,
	"./img/gonerdify.net_University.png": 184,
	"./img/n-it_1.png": 185,
	"./img/n-it_2.png": 186,
	"./img/n-it_3.png": 187,
	"./img/n-it_4.png": 188,
	"./img/screen_1.png": 189,
	"./img/screen_2.png": 190,
	"./img/screen_3.png": 191,
	"./img/screen_4.png": 192,
	"./img/slider-bg1.png": 193,
	"./img/slider-bg2.png": 194,
	"./img/the_1.png": 195,
	"./img/the_2.png": 196,
	"./img/the_3.png": 197,
	"./img/the_4.png": 198,
	"./slider.css": 79,
	"./slider.scss": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 167;